import AxiosJsonpAdapter from "axios-jsonp";

export const getAddress = async zipCode => {
	return await axios.get("https://zipcloud.ibsnet.co.jp/api/search", {
		adapter: AxiosJsonpAdapter,
		params: {
			zipcode: zipCode
		}
	});
};
